import './App.css';
import WeatherApp  from './Components/Weatherapp/WeatherApp.jsx';


function App() {
  return (
    <div className="App">
     <WeatherApp />
    </div>
  );
}

export default App;
